<mat-checkbox color="primary" checked="true" disabled="true">
  <span class="caption">Save settings across tasks</span>
</mat-checkbox>
